module.exports = __webpack_public_path__ + "static/media/expert-chat-fab-team.5eb86e95.png";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-SPRINT/expert-chat-fab-team.png
// module id = 2653
// module chunks = 0